export default __webpack_public_path__ + "static/articulation-f78b06b73a34af21920ab0b788fc7673.png";